<template>
  <a-row type="flex" justify="center" style="height: 5vh">
    <a-col :span="10" class="team_index_bar_item">
      <router-link to="/team_en/manager_adviser/manager">
        <div class="bar_item item_focus" tabindex="1" id="manager">Investment Management</div>
      </router-link>
    </a-col>
    <a-col :span="10" class="team_index_bar_item">
      <router-link to="/team_en/manager_adviser/adviser">
        <div class="bar_item" tabindex="2" id="adviser">Venture Consultants</div>
      </router-link>
    </a-col>
  </a-row>
</template>
<script>
import {onBeforeRouteUpdate} from 'vue-router'
import {onMounted} from "vue";

export default {
  name: 'Team_manager_adviser_bar_en',
  setup() {
    onBeforeRouteUpdate((from, to) => {
      let from_id = ''
      let to_id = ''
      if (from.name.search("manager") >= 0) {
        from_id = "manager"
      } else if (from.name.search("adviser") >= 0) {
        from_id = "adviser"
      }
      if (to.name.search("manager") >= 0) {
        to_id = "manager"
      } else if (to.name.search("adviser") >= 0) {
        to_id = "adviser"
      }
      //from 是下一个目标地址 to是上一个来源的地址
      document.getElementById(to_id).classList.remove("item_focus")
      document.getElementById(from_id).classList.add("item_focus")
    })

    onMounted(() => {
      if (document.getElementById("manager").classList.value.search("item_focus") >= 0) {
        document.getElementById("manager").classList.remove("item_focus")
      }
      if (document.getElementById("adviser").classList.value.search("item_focus") >= 0) {
        document.getElementById("adviser").classList.remove("item_focus")
      }
      if (window.location.href.search("manager_adviser/manager") >= 0) {
        document.getElementById("manager").classList.add("item_focus")
      } else if (window.location.href.search("manager_adviser/adviser") >= 0) {
        document.getElementById("adviser").classList.add("item_focus")
      }

    })
  }
}
</script>
<style scoped>
.team_index_bar_item {
  background: grey;
  line-height: 5vh;
  margin: 0.1vw;
}

.bar_item {
  color: white;
}

.item_focus {
  background-color: #2f54eb;
}
</style>